import React, { useEffect, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { Details } from './Details';
import { DetailsModal } from './DetailsModal';
import { Filter } from './Filter';
import { Table } from './Table';

export const AffiliateCommissions = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [requestAffiliateCommissionsDetails] = useCallbackObservable(
    affiliateId => affiliateCommissionsService.requestAffiliateCommissionsDetails(affiliateId),
    []
  );

  useEffect(() => {
    return () => affiliateCommissionsService.cleanFilter();
  }, []);

  if (isLoadingAccount || !user) return null;

  const handleSeeDetailsClick = (partnerId: number) => {
    requestAffiliateCommissionsDetails(partnerId);
    setIsDetailsModalOpen(true);
  };

  const closeDetailsModal = () => setIsDetailsModalOpen(false);

  return (
    <>
      <TopPage
        title='Comissões Pagas a Afiliados'
        extra='Verifique quanto você já pagou de comissão a seus afiliados.'
        disableAlerts
      />

      <Filter />
      <Details />
      <DetailsModal handleClose={closeDetailsModal} isOpen={isDetailsModalOpen} />
      <Table handleSeeDetailsClick={handleSeeDetailsClick} />
    </>
  );
};
